import { AmountMaskVariantTypeV2 } from '../../../../../components/amountMaskV2/types/amountMaskVariantType';
import { TextVariantType } from '../text/variants';
// Usando el nombre sin sufijo V2 para uso interno
export const commonStyles = (FOUNDATIONS, FONT, VARIANT_TOKENS) => ({
    kubitAccordion: {
        ...VARIANT_TOKENS.kubitAccordion,
    },
    amountMaskVariant: AmountMaskVariantTypeV2.REGULAR,
    // The container that holds the header elements (icon, title, amountMask and extra content)
    headerElementsContainer: {
        display: 'flex',
        flex_direction: 'column',
        width: '100%',
        gap: FOUNDATIONS.spacing_150,
        ...VARIANT_TOKENS.headerElementsContainer,
    },
    headerContent: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        ...VARIANT_TOKENS.headerContent,
    },
    icon: {
        color: FOUNDATIONS.color_comp_containers_accordion_icon,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        ...VARIANT_TOKENS.icon,
    },
    iconContainer: {
        align_self: 'start',
        ...VARIANT_TOKENS.iconContainer,
    },
    amountMaskContainer: {
        display: 'flex',
        align_items: 'start',
        flex_shrink: '0',
        padding_left: FOUNDATIONS.spacing_150,
        ...VARIANT_TOKENS.amountMaskContainer,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_comp_containers_accordion_font,
        text_align: 'start',
        ...VARIANT_TOKENS.title,
    },
    titleContainer: {
        display: 'flex',
        flex: '1',
        align_items: 'center',
        ...VARIANT_TOKENS.titleContainer,
    },
    headerExtraContent: {
        ...VARIANT_TOKENS.headerExtraContent,
    },
});
//# sourceMappingURL=commonStyles.js.map